import { useEffect, useState } from "react"
import { axios } from "../../helpers"

const useAnnouncement = () => {
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [keyword, setKeyword] = useState("")

    useEffect(() => {
        const delayDebouncer = setTimeout(() => {
            fetchDocument(1)
        }, 500)
        return () => clearTimeout(delayDebouncer)
    }, [keyword])

    const fetchDocument = async (page) => {
        setIsLoading(true)
        try {

            const response = await axios.get(`/pengumuman`)

            if (response.status === 200) {
                setData(response.data.data.rows)
            }
        } catch (error) {
            console.log(error);

        } finally {
            setIsLoading(false)
        }

    }

    return {
        data,
        isLoading,
    }
}
export default useAnnouncement